/* GENERATED — do not edit.
   Source: clients/profit_minded/site_rebuild/_gen_mockups.py PDP_JS (mock stripped)
   Regenerate: python clients/profit_minded/theme_variant_a/_derive_assets.py */
/* ===== pm-product.js =======================================================
   Variant state machine for a product with ANY number of options.

   Measured across this catalog: 33 of 42 products have a single (Size) option,
   4 have (Size, Color), 2 have (Color, SIZE), 1 has (Color, Size), 1 has
   (Size, Care instructions) and 1 has none at all. So nothing here may assume an
   option's position or its name — options are read from the payload, by index.

   Reads a TRIMMED variant projection from an application/json blob — never a JS
   constant, and never the full product JSON, which would publish the whole
   inventory table.

   The <select name="id"> is the source of truth for what the form posts. This
   script hides its wrapper and drives .value; it never replaces it. That is what
   keeps the no-JS path working.
   ========================================================================= */
(function () {
  var root = document.querySelector('[data-pm-pdp]');
  if (!root) return;

  var P    = JSON.parse(document.querySelector('[data-pm-product]').textContent);
  var STR  = JSON.parse(document.querySelector('[data-pm-pdp-strings]').textContent);
  var form = root.querySelector('[data-pm-atc-form]');
  var sel  = root.querySelector('[data-pm-variant-select]');
  var nojs = root.querySelector('[data-pm-nojs]');
  var atc  = root.querySelector('[data-pm-atc]');
  var err  = root.querySelector('[data-pm-atc-err]');
  var note = root.querySelector('[data-pm-stock-note]');
  /* Back-in-stock block. Lives OUTSIDE the product <form> (nested forms are invalid
     HTML and the inner one is discarded by the parser), so it is looked up from the
     section root rather than from the form. Null on any PDP that does not render it. */
  var notify = root.querySelector('[data-pm-notify]');
  var notifyBody = root.querySelector('[data-pm-notify-body]');
  var track = root.querySelector('[data-pm-gal-track]');
  var count = root.querySelector('[data-pm-gal-count]');
  var bar   = document.querySelector('[data-pm-buybar]');
  var barBtn = bar && bar.querySelector('[data-pm-atc-proxy]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var N = P.options.length;

  /* A hidden element still submits, so the select keeps carrying name="id". */
  if (nojs) nojs.hidden = true;

  /* state.o[i] is the chosen value for option i, or null. */
  var state = { o: [] };
  /* Declared here, not next to the handlers, because update() reads it and update()
     is defined above them. `var` hoisting would make it work either way; relying on
     that to keep a disabled-button computation correct is not worth the cleverness. */
  var inFlight = false;

  /* SEED FROM THE SELECT BEFORE fillDefaults() EVER RUNS.
     The <select name="id"> is the form's source of truth and it is VISIBLE AND
     USABLE for seconds before this script executes -- that is the whole window
     pm-atc-guard exists to cover. Starting from an empty state.o and letting
     fillDefaults() pick from its own preference order silently discards a size the
     shopper already chose, and on a store where every sale is final that is a
     wrong-size order, not a cosmetic bug.
     Only a value that resolves to a real variant is trusted; anything else falls
     through to the defaults exactly as before. */
  function seedFromSelect() {
    if (!sel || !sel.value) return;
    var chosen = null;
    for (var i = 0; i < P.variants.length; i++) {
      if (String(P.variants[i].id) === String(sel.value)) { chosen = P.variants[i]; break; }
    }
    if (!chosen || !chosen.o) return;
    for (var j = 0; j < N; j++) if (chosen.o[j] != null) state.o[j] = chosen.o[j];
  }

  /* Match on the values a shopper has actually chosen; a null slot is a wildcard,
     so this doubles as "is any variant still reachable from here". */
  function match(probe) {
    return P.variants.filter(function (v) {
      for (var i = 0; i < N; i++) if (probe[i] != null && v.o[i] !== probe[i]) return false;
      return true;
    });
  }
  function exact() {
    for (var i = 0; i < N; i++) if (state.o[i] == null) return null;
    return match(state.o)[0] || null;
  }
  /* Availability CASCADES: option i is judged against the options BEFORE it only,
     with everything after it left as a wildcard.

     Judging against every other choice instead looks reasonable and is wrong — it
     greys out a colour merely because the size you happen to have selected is not
     stocked in it, so a shopper who picks M watches half the colourway row die and
     concludes the product is sold out. Cascading means the first option shows true
     global availability and each later one narrows against what is already chosen,
     which is also what Shopify's own themes do. */
  function reachable(i, val) {
    var probe = [];
    for (var k = 0; k < i; k++) probe[k] = state.o[k];
    probe[i] = val;
    return match(probe).some(function (v) { return v.a; });
  }

  /* The size-ish option gets the middle-outward preference, because a shopper who
     has not chosen is likeliest to want the middle of a size run. Every other
     option takes its first reachable value. Ties break toward the lower index. */
  function preferenceOrder(i) {
    var vals = P.options[i].values;
    var ranked = vals.map(function (v, k) { return { v: v, k: k, d: 0 }; });
    if (i !== P.sizeOption) return ranked;
    var mid = (vals.length - 1) / 2;
    ranked.forEach(function (r) { r.d = Math.abs(r.k - mid); });
    return ranked.sort(function (x, y) { return x.d - y.d || x.k - y.k; });
  }
  function defaultFor(i) {
    var order = preferenceOrder(i);
    for (var j = 0; j < order.length; j++) if (reachable(i, order[j].v)) return order[j].v;
    return null;
  }
  /* Fill every unset (or newly stranded) slot, left to right. Derrick 2026-09-01:
     a size is always preselected so ADD TO BAG is live on arrival, and the picker
     is only touched to CHANGE something. */
  function fillDefaults() {
    for (var i = 0; i < N; i++) {
      if (state.o[i] == null || !reachable(i, state.o[i])) state.o[i] = defaultFor(i);
    }
  }

  function update() {
    [].forEach.call(root.querySelectorAll('[data-pm-opt]'), function (b) {
      var i = parseInt(b.getAttribute('data-pm-opt'), 10);
      var val = b.getAttribute('data-pm-val');
      b.setAttribute('aria-checked', state.o[i] === val ? 'true' : 'false');
      var ok = reachable(i, val);
      b.setAttribute('data-avail', ok ? 'true' : 'false');
      b.setAttribute('aria-disabled', ok ? 'false' : 'true');
    });
    [].forEach.call(root.querySelectorAll('[data-pm-opt-val]'), function (n) {
      var i = parseInt(n.getAttribute('data-pm-opt-val'), 10);
      n.textContent = state.o[i] || '';
    });

    var v = P.hasOptions ? exact() : (P.variants[0] || null);
    if (v && sel) sel.value = String(v.id);
    if (note) note.textContent = (v && v.low) ? STR.lowstock.replace('{n}', v.low) : '';

    var anyStock = P.variants.some(function (x) { return x.a; });
    /* ONE WRITER for `disabled`, computed from BOTH inputs.
       Availability is this function's business; "the guard is holding a tap that
       has not resumed yet" is pm-atc-guard's. Before this was combined here, three
       different places wrote the property -- update(), the guard, and PMCart.add()
       (which cleared it UNCONDITIONALLY on completion, re-enabling a SOLD-OUT
       button after any add). Whoever writes last wins, and that is not a state
       machine. The guard now only ever sets the attribute; the value is derived
       here, so guard-busy can never resurrect an unavailable variant. */
    var guardBusy = atc.hasAttribute('data-pm-guard-busy');
    atc.disabled = guardBusy || inFlight || !(v && v.a);
    atc.textContent = !anyStock ? STR.soldout_all
                    : (v && v.a) ? STR.atc
                    : state.o.indexOf(null) > -1 ? STR.select_prompt
                    : STR.soldout_size;
    if (barBtn) { barBtn.disabled = atc.disabled; barBtn.textContent = atc.textContent; }

    /* Back-in-stock capture. Shown exactly when the CHOSEN combination cannot be
       bought — including the case where the whole product is gone. The markup is
       server-rendered for the initially-selected variant and only toggled here.

       The hidden contact[body] carries the specific variant, because "someone wants
       this product" is not actionable and "someone wants CAMO / L" is. Written on
       every update so it always matches what is on screen at submit time. */
    if (notify) {
      var wanted = !(v && v.a);
      notify.hidden = !wanted;
      if (wanted && notifyBody) {
        var chosen = state.o.filter(function (x) { return x; }).join(' / ');
        notifyBody.value = 'Back-in-stock request: ' + P.title +
                           (chosen ? ' (' + chosen + ')' : '');
      }
    }
  }

  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-pm-opt]');
    if (!b) return;
    if (b.getAttribute('data-avail') === 'false') return;
    var i = parseInt(b.getAttribute('data-pm-opt'), 10);
    state.o[i] = b.getAttribute('data-pm-val');
    /* Changing one option can strand another (this colour has no XXL). Refill the
       stranded slots rather than clearing them, so ADD TO BAG stays live. */
    fillDefaults();
    err.hidden = true;
    update();
    showValue(i, state.o[i]);
  });

  /* Move the mobile strip to the frame for this value, when the option is
     image-backed. On desktop the images are stacked in a scrolling column, and
     hijacking page scroll on a swatch click would yank the shopper away from the
     control they just used. */
  function showValue(i, val) {
    var slide = P.options[i].slide || {};
    var idx = slide[val];
    if (idx == null || !track) return;
    if (window.matchMedia('(min-width:900px)').matches) return;
    var el = track.children[idx];
    if (!el) return;
    track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
  }

  if (track && count) {
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth) + 1;
        count.textContent = Math.min(Math.max(i, 1), track.children.length) + ' / ' + track.children.length;
      }, 80);
    }, { passive: true });
  }

  /* In-flight is OUR state, not the cart module's. PMCart.add() used to be handed
     the button and would disable it on entry and clear it on exit -- the second
     writer described in update(). It is passed `null` now, so the cart module never
     touches a PDP control, and the busy state is folded into update()'s one
     computation instead. */
  function addVariant(v, btn) {
    if (inFlight) return Promise.resolve();
    inFlight = true;
    update();
    /* Hand the cart everything it needs to paint the line immediately. All of it is
       already on this page, so the drawer opens on the same frame as the tap rather
       than after a round trip. */
    var slide = P.options.length ? P.options[0].slide || {} : {};
    var idx = slide[state.o[0]];
    var el = track && track.children[idx == null ? 0 : idx];
    var img = el && el.querySelector('img');
    return window.PMCart.add(v.id, 1, null, {
      title: P.title,
      variant: P.hasOptions ? v.o.filter(Boolean).join(' / ') : '',
      price: Math.round(v.p * 100),
      image: img ? (img.currentSrc || img.getAttribute('src')) : '',
      url: '/products/' + P.handle
    }).then(function () { inFlight = false; update(); },
            function () { inFlight = false; update(); });
  }

  function submit(btn) {
    var v = P.hasOptions ? exact() : (P.variants[0] || null);
    if (!v || !v.a) return;
    err.hidden = true;
    if (!window.PMCart) { form.submit(); return; }
    addVariant(v, btn);
  }

  /* Paint on CLICK CAPTURE, not on submit.
     Measured on the real storefront: the click handler's own work is ~25ms, but a
     tap took ~576ms to show anything. The gap is third-party listeners on the
     form's `submit` event — cart and upsell apps hook exactly that, and they run
     before our code does. We cannot remove them (apps are audit-only here), but we
     do not have to queue behind them: `click` fires before `submit`, and capture
     runs before bubble, so painting here puts the drawer on screen first and lets
     the app code run afterwards.
     `submit` still owns the network call and the no-JS fallback. */
  var painted = false;

  atc.addEventListener('click', function () {
    if (!window.PMCart || atc.disabled) return;
    var v = P.hasOptions ? exact() : (P.variants[0] || null);
    if (!v || !v.a) return;
    painted = true;
    submit(atc);
  }, true);

  form.addEventListener('submit', function (ev) {
    if (!window.PMCart) return;          /* no cart JS -> let the real form post */
    ev.preventDefault();
    if (painted) { painted = false; return; }   /* already handled on click capture */
    submit(atc);
  });
  if (barBtn) barBtn.addEventListener('click', function () { submit(barBtn); });

  document.addEventListener('pm:cart:error', function () {
    err.textContent = STR.add_error;
    err.hidden = false;
  });

  /* Sticky mobile buy bar — appears only once the real control leaves the viewport. */
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.setAttribute('data-shown', entries[0].isIntersecting ? 'false' : 'true');
    }, { rootMargin: '0px 0px -40px 0px' }).observe(atc);
  }

  /* ===== the resume API pm-atc-guard replays through ======================
     NOT a synthetic click. A replayed click re-enters the handler above, which
     reads whatever `state.o` happens to hold NOW -- so a snapshot taken when the
     shopper tapped would be checked and then thrown away, and a selection changed
     in between would either substitute a variant or cancel a valid add. This
     consumes the snapshot instead, and honours it exactly or refuses.

     Never substitutes. A cancellation returns a reason so the guard can announce
     it and leave the surface retryable, which is the whole contract. */
  function resume(snap) {
    var id = snap && snap.id;
    var v = null;
    for (var i = 0; i < P.variants.length; i++) {
      if (String(P.variants[i].id) === String(id)) { v = P.variants[i]; break; }
    }
    if (!v) return { ok: false, reason: 'unknown-variant' };
    if (!v.a) return { ok: false, reason: 'unavailable' };
    if (!window.PMCart) return { ok: false, reason: 'no-cart' };
    /* Adopt the snapshot's variant as the selection, so the picker, the gallery and
       the hidden <select> all agree with what is about to be added. */
    if (v.o) for (var j = 0; j < N; j++) if (v.o[j] != null) state.o[j] = v.o[j];
    err.hidden = true;
    update();
    addVariant(v, null);
    return { ok: true, id: v.id };
  }

  /* The guard writes data-pm-guard-busy; only update() derives `disabled` from it. */
  window.PMPdp = {
    resume: resume,
    refresh: function () { update(); },
    /* The activation-time payload the guard snapshots. Read from the SELECT, which
       is what a native POST would have sent -- not from state.o, which may not
       exist yet at the moment of the tap. */
    snapshot: function () {
      return { host: 'pdp', id: (sel && sel.value) || '' };
    }
  };

  seedFromSelect();
  fillDefaults();
  update();

  /* READINESS IS PUBLISHED LAST, AFTER STATE EXISTS -- not after binding.
     Dispatch is synchronous, so a guard resuming on this event runs before the next
     statement here does. Marking ready at bind time (the handlers are attached ~100
     lines above) would resume into an empty state.o and add a default size. */
  form.setAttribute('data-pm-ready', '');
  document.dispatchEvent(new CustomEvent('pm:pdp:ready'));
})();
